import {
  UPDATEGATEWAYTRANSACTIONSTATUSADMIN_SUCCESS,
  UPDATEGATEWAYTRANSACTIONSTATUSADMIN_FAILED,
  RESET_UPDATEGATEWAYTRANSACTIONSTATUSADMIN,
  LOADING_UPDATEGATEWAYTRANSACTIONSTATUSADMIN,
  NETWORK_ERROR_UPDATEGATEWAYTRANSACTIONSTATUSADMIN,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_UPDATEGATEWAYTRANSACTIONSTATUSADMIN:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case UPDATEGATEWAYTRANSACTIONSTATUSADMIN_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case UPDATEGATEWAYTRANSACTIONSTATUSADMIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_UPDATEGATEWAYTRANSACTIONSTATUSADMIN:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_UPDATEGATEWAYTRANSACTIONSTATUSADMIN:
      return (state = initialState);
    default:
      return state;
  }
};
